export const caseSource = {
    COMPANY: 'אתר חברה',
    HARBITUAH: 'הר ביטוח',
    SYSTEM: 'מערכת'
}